import { AppEnvironment } from '@core/api';

export const environment = {
  env: AppEnvironment.Dev,
  googleClientId: '581674931599-r14qudqmijipt03fl6acm856dklbk3kt.apps.googleusercontent.com',
  boGoogleClientId: '605507710056-6otrcvt6oku9am5klorkqevisvuno5tk.apps.googleusercontent.com',
  apiHost: 'https://api-dev.pin-up-chatbots.com/api/v1',
  grpcHost: 'https://api-grpc-dev.pin-up-chatbots.com',
  isInternalDev: true,
};
